import gql from 'graphql-tag';

export const LISTINGS_QUERY = gql`
    query getListingData($path: String!) {
        breadcrumbs(path: $path) {
            label
            tracking
            uri
            noAppend
            i18nLabelKey
        }
        seoAccordions(path: $path) {
            category
            expanded
            geo
            name
            propertyType
            section
            transactionType
            rows {
                links {
                    category
                    geo
                    propertyType
                    section
                    transactionType
                    uri
                }
            }
            links {
                category
                geo
                propertyType
                section
                transactionType
                uri
            }
        }
        discoverMore(path: $path) {
            housePricesUri
            findAgentsUri
        }
        searchResults(path: $path) {
            analyticsTaxonomy {
                url
                areaName
                activity
                brand
                countryCode
                countyAreaName
                currencyCode
                listingsCategory
                outcode
                outcodes
                page
                postalArea
                radius
                radiusAutoexpansion
                regionName
                resultsSort
                searchGuid
                searchIdentifier
                section
                searchLocation
                viewType
                searchResultsCount
                expandedResultsCount
                totalResults
                emailAllFormShown
                emailAllTotalAgents
                bedsMax
                bedsMin
                priceMax
                priceMin
                location
                propertyType
            }
            analyticsEcommerce {
                currencyCode
                impressions {
                    id
                    list
                    position
                    variant
                }
            }
            adTargeting {
                activity
                areaName
                bedsMax
                bedsMin
                brand
                brandPrimary
                countyAreaName
                countryCode
                currencyCode
                listingsCategory
                outcode
                outcodes
                page
                postalArea
                priceMax
                priceMin
                propertyType
                regionName
                resultsSort
                searchLocation
                searchResultsCount
                section
                totalResults
                url
                viewType
            }
            metaInfo {
                title
                description
                canonicalUri
            }
            pagination {
                pageNumber
                totalResults
                totalResultsWasLimited
            }
            listings {
                regular {
                    numberOfVideos
                    numberOfImages
                    numberOfFloorPlans
                    numberOfViews
                    listingId
                    title
                    publishedOnLabel
                    publishedOn
                    availableFrom
                    priceDrop {
                        lastPriceChangeDate
                        percentageChangeLabel
                    }
                    isPremium
                    highlights {
                        description
                        label
                        url
                    }
                    otherPropertyImages {
                        small
                        large
                        caption
                    }
                    branch {
                        name
                        branchDetailsUri
                        phone
                        logoUrl
                        branchId
                    }
                    features {
                        content
                        iconId
                    }
                    image {
                        src
                        caption
                        responsiveImgList {
                            width
                            src
                        }
                    }
                    transports {
                        title
                        poiType
                        distanceInMiles
                        features {
                            zone
                            tubeLines
                        }
                    }
                    flag
                    listingId
                    priceTitle
                    price
                    alternativeRentFrequencyLabel
                    address
                    tags {
                        content
                    }
                    listingUris {
                        contact
                        detail
                    }
                }
                extended {
                    numberOfVideos
                    numberOfImages
                    numberOfFloorPlans
                    numberOfViews
                    listingId
                    title
                    publishedOnLabel
                    publishedOn
                    availableFrom
                    priceDrop {
                        lastPriceChangeDate
                        percentageChangeLabel
                    }
                    isPremium
                    highlights {
                        description
                        label
                        url
                    }
                    otherPropertyImages {
                        small
                        large
                        caption
                    }
                    branch {
                        name
                        branchDetailsUri
                        phone
                        logoUrl
                        branchId
                    }
                    features {
                        content
                        iconId
                    }
                    image {
                        src
                        caption
                        responsiveImgList {
                            width
                            src
                        }
                    }
                    transports {
                        title
                        poiType
                        distanceInMiles
                        features {
                            zone
                            tubeLines
                        }
                    }
                    flag
                    listingId
                    priceTitle
                    price
                    alternativeRentFrequencyLabel
                    address
                    tags {
                        content
                    }
                    listingUris {
                        contact
                        detail
                    }
                }
                featured {
                    numberOfVideos
                    numberOfImages
                    numberOfFloorPlans
                    numberOfViews
                    listingId
                    title
                    publishedOnLabel
                    publishedOn
                    availableFrom
                    priceDrop {
                        lastPriceChangeDate
                        percentageChangeLabel
                    }
                    isPremium
                    featuredType
                    highlights {
                        description
                        label
                        url
                    }
                    otherPropertyImages {
                        small
                        large
                        caption
                    }
                    branch {
                        name
                        branchDetailsUri
                        phone
                        logoUrl
                    }
                    features {
                        content
                        iconId
                    }
                    image {
                        src
                        caption
                        responsiveImgList {
                            width
                            src
                        }
                    }
                    transports {
                        title
                        poiType
                        distanceInMiles
                        features {
                            zone
                            tubeLines
                        }
                    }
                    flag
                    listingId
                    priceTitle
                    price
                    alternativeRentFrequencyLabel
                    address
                    tags {
                        content
                    }
                    listingUris {
                        contact
                        detail
                    }
                }
            }
            filters {
                fields {
                    group
                    fieldName
                    label
                    isRequired
                    inputType
                    placeholder
                    allowMultiple
                    options
                    value
                }
            }
            links {
                saveSearch
                createAlert
            }
            sortOrder {
                currentSortOrder
                options {
                    i18NLabelKey
                    value
                }
            }
            seoBlurb {
                category
                transactionType
            }
            title
            userAlertId
            savedSearchAndAlerts {
                uri
                currentFrequency {
                    i18NLabelKey
                    value
                }
            }
            polyenc
        }
    }
`;

export const USER_FAVOURITES_QUERY = gql`
    query userFavourites {
        favourites {
            listings
        }
    }
`;

export const SAVE_LISTING = gql`
    mutation favouriteListing($id: ID!) {
        saveFavouriteListing(id: $id)
    }
`;

export const DELETE_LISTING = gql`
    mutation unfavouriteListing($id: ID!) {
        deleteFavouriteListing(id: $id)
    }
`;

export const CONTACT_AGENTS = gql`
    mutation emailAll($input: EmailAllDetails!) {
        contactAgents(input: $input) {
            emailAll {
                action
                branches {
                    checked
                    featured
                    label
                    logo
                    name
                    type
                    telephone
                    value
                }
                branchesValidation {
                    requiredError
                }
                formConfig {
                    fields {
                        fieldset {
                            fields {
                                name
                                placeholder
                                type
                                value
                                i18NLabelKey
                                maxlength
                                optional
                                validationData {
                                    pattern
                                    patternError
                                    required
                                    requiredError
                                }
                                options {
                                    disabled
                                    i18NLabelKey
                                    label
                                    selected
                                    value
                                }
                            }
                            hideLegend
                            i18NLegendKey
                            name
                        }
                    }
                }
                showCaptcha
            }
            result {
                branches {
                    address
                    branchDetailsUri
                    branchDetailsUrl
                    branchId
                    companyId
                    companyName
                    logoUrl
                    memberType
                    name
                    phone
                    postcode
                }
                leadIdentifier
                message
                trackingObjects {
                    ecommerce {
                        purchase {
                            actionField {
                                affiliation
                                id
                                revenue
                            }
                            products {
                                brand
                                category
                                coupon
                                id
                                name
                                position
                                price
                                quantity
                                variant
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const EMAIL_ALL_QUERY = gql`
    query getEmailAll($path: String!) {
        emailAll(path: $path) {
            action
            branches {
                checked
                featured
                label
                logo
                name
                type
                telephone
                value
            }
            formConfig {
                fields {
                    fieldset {
                        fields {
                            name
                            placeholder
                            type
                            value
                            i18NLabelKey
                            maxlength
                            optional
                            validationData {
                                pattern
                                required
                            }
                            options {
                                disabled
                                i18NLabelKey
                                label
                                selected
                                value
                            }
                        }
                        hideLegend
                        i18NLegendKey
                        name
                    }
                }
            }
            showCaptcha
        }
    }
`;

export const LISTINGS_QUERY_V2 = gql`
    query getListingDataV2($path: String!) {
        breadcrumbs(path: $path) {
            label
            tracking
            uri
            noAppend
            i18nLabelKey
        }
        seoAccordions(path: $path) {
            category
            expanded
            geo
            name
            propertyType
            section
            transactionType
            rows {
                links {
                    category
                    geo
                    propertyType
                    section
                    transactionType
                    uri
                }
            }
            links {
                category
                geo
                propertyType
                section
                transactionType
                uri
            }
        }
        discoverMore(path: $path) {
            housePricesUri
            findAgentsUri
        }
        searchResultsV2(input: { path: $path }) {
            analyticsTaxonomy {
                url
                areaName
                activity
                brand
                countryCode
                countyAreaName
                currencyCode
                listingsCategory
                outcode
                outcodes
                page
                postalArea
                radius
                radiusAutoexpansion
                regionName
                resultsSort
                searchGuid
                searchIdentifier
                section
                searchLocation
                viewType
                searchResultsCount
                expandedResultsCount
                totalResults
                emailAllFormShown
                emailAllTotalAgents
                bedsMax
                bedsMin
                priceMax
                priceMin
                location
                propertyType
            }
            analyticsEcommerce {
                currencyCode
                impressions {
                    id
                    list
                    position
                    variant
                }
            }
            adTargeting {
                activity
                areaName
                bedsMax
                bedsMin
                brand
                brandPrimary
                countyAreaName
                countryCode
                currencyCode
                listingsCategory
                outcode
                outcodes
                page
                postalArea
                priceMax
                priceMin
                propertyType
                regionName
                resultsSort
                searchLocation
                searchResultsCount
                section
                totalResults
                url
                viewType
            }
            metaInfo {
                title
                description
                canonicalUri
            }
            pagination {
                pageNumber
                totalResults
                totalResultsWasLimited
            }
            results {
                main {
                    data {
                        ... on FeedListingItem {
                            listing {
                                numberOfVideos
                                numberOfImages
                                numberOfFloorPlans
                                numberOfViews
                                listingId
                                title
                                publishedOnLabel
                                publishedOn
                                availableFrom
                                priceDrop {
                                    lastPriceChangeDate
                                    percentageChangeLabel
                                }
                                isPremium
                                highlights {
                                    description
                                    label
                                    url
                                }
                                otherPropertyImages {
                                    small
                                    large
                                    caption
                                }
                                branch {
                                    name
                                    branchDetailsUri
                                    phone
                                    logoUrl
                                    branchId
                                }
                                features {
                                    content
                                    iconId
                                }
                                image {
                                    src
                                    caption
                                    responsiveImgList {
                                        width
                                        src
                                    }
                                }
                                transports {
                                    title
                                    poiType
                                    distanceInMiles
                                    features {
                                        zone
                                        tubeLines
                                    }
                                }
                                flag
                                listingId
                                priceTitle
                                price
                                alternativeRentFrequencyLabel
                                address
                                tags {
                                    content
                                }
                                listingUris {
                                    contact
                                    detail
                                }
                            }
                            presentationType
                        }
                    }
                }
                extended {
                    numberOfVideos
                    numberOfImages
                    numberOfFloorPlans
                    numberOfViews
                    listingId
                    title
                    publishedOnLabel
                    publishedOn
                    availableFrom
                    priceDrop {
                        lastPriceChangeDate
                        percentageChangeLabel
                    }
                    isPremium
                    highlights {
                        description
                        label
                        url
                    }
                    otherPropertyImages {
                        small
                        large
                        caption
                    }
                    branch {
                        name
                        branchDetailsUri
                        phone
                        logoUrl
                        branchId
                    }
                    features {
                        content
                        iconId
                    }
                    image {
                        src
                        caption
                        responsiveImgList {
                            width
                            src
                        }
                    }
                    transports {
                        title
                        poiType
                        distanceInMiles
                        features {
                            zone
                            tubeLines
                        }
                    }
                    flag
                    listingId
                    priceTitle
                    price
                    alternativeRentFrequencyLabel
                    address
                    tags {
                        content
                    }
                    listingUris {
                        contact
                        detail
                    }
                }
            }
            filters {
                fields {
                    group
                    fieldName
                    label
                    isRequired
                    inputType
                    placeholder
                    allowMultiple
                    options
                    value
                }
            }
            links {
                saveSearch
                createAlert
            }
            sortOrder {
                currentSortOrder
                options {
                    i18NLabelKey
                    value
                }
            }
            seoBlurb {
                category
                transactionType
            }
            title
            userAlertId
            savedSearchAndAlerts {
                uri
                currentFrequency {
                    i18NLabelKey
                    value
                }
            }
            polyenc
        }
    }
`;
